<template>
  <section class="greet">
    <img
      v-if="isMobile"
      class="greet__video--fallback hidden--md img-responsive"
      :src="videoImg"
    />
    <video
      v-else
      ref="backgroundMainVideo"
      class="greet__video hidden--md"
      width="100%"
      height="auto"
      autoplay
      loop
      muted
    >
      <source src="/static/img/videos/mdz-bg.webm" type="video/webm" />
      <source src="/static/img/videos/mdz-bg.mp4" type="video/mp4" />
      <source src="/static/img/videos/mdz-bg.ogv" type="video/ogg" />
      <div style="height: 650px; width: 100%"></div>
    </video>

    <div class="greet__background-mobile show--md"></div>

    <div class="greet__content">
      <h1 class="greet__header">
        <div class="greet__header-small">NO RULES, EXCEPT ONE:</div>
        <div class="greet__header-big">To survive</div>
      </h1>
      <div class="greet__play">
        <h2 class="greet__play-header">100% free, play now!</h2>
        <play-buttons class="greet__play-button-wrap" />
      </div>
    </div>

    <social-widget></social-widget>
  </section>
</template>
<script>
import SocialWidget from "../SocialWidget.vue";
import PlayButtons from "../common/PlayButtons";
import WebPicture from "../WebPicture";

import videoImg from "../../../assets/img/video.jpg";

export default {
  components: {
    "social-widget": SocialWidget,
    "play-buttons": PlayButtons,
    WebPicture
  },
  data() {
    return {
      videoImg
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.settings.isMobile;
    }
  },
  created() {
    let video = this.$refs.backgroundMainVideo;
    if (video) {
      video.play();
    }
  }
};
</script>
